<template>
  <v-container fluid class="px-0 pt-2 mt-4">
    <v-layout column>
      <v-data-table
        dense
        :headers="headers"
        :items="gpVSCostItems"
        :items-per-page="-1"
        class="elevation-2"
      >
        <template v-slot:item.january="{ item }">
          {{ item.january | currency }}
        </template>
        <template v-slot:item.february="{ item }">
          {{ item.february | currency }}
        </template>
        <template v-slot:item.march="{ item }">
          {{ item.march | currency }}
        </template>
        <template v-slot:item.april="{ item }">
          {{ item.april | currency }}
        </template>
        <template v-slot:item.may="{ item }">
          {{ item.may | currency }}
        </template>
        <template v-slot:item.june="{ item }">
          {{ item.june | currency }}
        </template>
        <template v-slot:item.july="{ item }">
          {{ item.july | currency }}
        </template>
        <template v-slot:item.august="{ item }">
          {{ item.august | currency }}
        </template>
        <template v-slot:item.september="{ item }">
          {{ item.september | currency }}
        </template>
        <template v-slot:item.october="{ item }">
          {{ item.october | currency }}
        </template>
        <template v-slot:item.november="{ item }">
          {{ item.november | currency }}
        </template>
        <template v-slot:item.december="{ item }">
          {{ item.december | currency }}
        </template>
        <template v-slot:item.yearToDateGrossProfit="{ item }">
          {{ item.yearToDateGrossProfit | currency }}
        </template>
        <template v-slot:item.projectedGrossProfit="{ item }">
          {{ item.projectedGrossProfit | currency }}
        </template>
        <template v-slot:item.seatRevenue="{ item }">
          {{ item.seatRevenue | currency }}
        </template>
        <template v-slot:item.seatCost="{ item }">
          {{ item.seatCost | currency }}
        </template>
      </v-data-table>
    </v-layout>
  </v-container>
</template>

<script>

import { mapFields } from '@/vueHelpers/vuex'

export default {
  props: [
    'gpVSCostItems'
  ],
  computed: {
    ...mapFields('gpToCostReportFilters', [
      'year'
    ]),
    headers () {
      let month
      if (this.year < new Date().getFullYear()) {
        month = 12
      } else {
        month = new Date().getMonth() + 1
      }
      const headers = [
        { text: 'Employee', value: 'employeeName', width: '220px' }
      ]

      for (let i = 1; i <= month; i++) {
        switch (i) {
          case 1:
            headers.push({ text: 'January', value: 'january', width: '120px', align: 'center', cellClass: 'text-end' })
            break
          case 2:
            headers.push({ text: 'February', value: 'february', width: '120px', align: 'center', cellClass: 'text-end' })
            break
          case 3:
            headers.push({ text: 'March', value: 'march', width: '120px', align: 'center', cellClass: 'text-end' })
            break
          case 4:
            headers.push({ text: 'April', value: 'april', width: '120px', align: 'center', cellClass: 'text-end' })
            break
          case 5:
            headers.push({ text: 'May', value: 'may', width: '120px', align: 'center', cellClass: 'text-end' })
            break
          case 6:
            headers.push({ text: 'June', value: 'june', width: '120px', align: 'center', cellClass: 'text-end' })
            break
          case 7:
            headers.push({ text: 'July', value: 'july', width: '120px', align: 'center', cellClass: 'text-end' })
            break
          case 8:
            headers.push({ text: 'August', value: 'august', width: '120px', align: 'center', cellClass: 'text-end' })
            break
          case 9:
            headers.push({ text: 'September', value: 'september', width: '120px', align: 'center', cellClass: 'text-end' })
            break
          case 10:
            headers.push({ text: 'October', value: 'october', width: '120px', align: 'center', cellClass: 'text-end' })
            break
          case 11:
            headers.push({ text: 'November', value: 'november', width: '120px', align: 'center', cellClass: 'text-end' })
            break
          case 12:
            headers.push({ text: 'December', value: 'december', width: '120px', align: 'center', cellClass: 'text-end' })
            break
        }
      }

      headers.push(
        { text: 'YTD GP', value: 'yearToDateGrossProfit', width: '120px', align: 'center', cellClass: 'text-end' },
        { text: 'Projected', value: 'projectedGrossProfit', width: '120px', align: 'center', cellClass: 'text-end' },
        { text: 'Seat Cost', value: 'seatCost', width: '120px', align: 'center', cellClass: 'text-end' },
        { text: 'Seat Revenue', value: 'seatRevenue', width: '150px', align: 'center', cellClass: 'text-end' }
      )

      return headers
    }
  }
}
</script>
